import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _get from 'lodash/get';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './AddMembers.module.css';
import Input from 'components/UI/Input/Input';
import Modal from 'components/UI/Modal/Modal';
import { checkValidity, getRgbFromColorName, truncateText, updateObject } from 'shared/utility';
import * as actions from 'store/actions';

class AddMembers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchInput: '',
      selectedMembers: [],
      userSearchResults: [],
      // inviteUsersEmail: [],
      controls: {
        firstName: {
          elementType: 'input',
          elementConfig: {
            type: 'input',
            placeholder: 'First Name',
          },
          value: '',
          fontIcon: 'users',
          validation: {
            required: true,
            validationError: 'First name required',
          },
          valid: false,
          touched: false,
        },
        email: {
          elementType: 'input',
          elementConfig: {
            type: 'email',
            placeholder: 'Email Address',
          },
          value: '',
          validation: {
            required: false,
            isEmail: true,
            validationError: 'Please enter a valid email address',
          },
          valid: false,
          touched: false,
        },
        mobileNumber: {
          elementType: 'input',
          elementConfig: {
            type: 'tel',
            placeholder: 'Phone Number',
          },
          value: '',
          validation: {
            required: false,
            validationError: 'Please enter a valid phone number',
          },
          valid: true,
          touched: false,
        },
        message: {
          elementType: 'textarea',
          elementConfig: {
            type: 'textarea',
            placeholder: 'Invitation Message',
          },
          value:
            `Hi there! I would like to invite you to a log I’ve created for us using Riza.` +
            `Check it out! \r\n\n-${this.props.postingAs.FirstName}`,
          validation: {
            required: false,
            validationError: 'Please enter an invitation message',
          },
          valid: true,
          touched: false,
        },
      },
      showInviteModal: false,
      formIsValid: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.userSearchResults !== prevProps.userSearchResults) {
      this.setState({ userSearchResults: this.props.userSearchResults.filter((user) => user.UserId !== this.props.postingAs.UserId) });
    }
    // Reset once selected members have been succesfully added to the log
    if (this.props.existingMembers !== prevProps.existingMembers && this.state.selectedMembers.length > 0)
      this.setState({ userSearchResults: [], searchInput: '', selectedMembers: [] });
    // Hide invite modal when an invitation is successfully submitted
    if (this.props.inviteSubmitted && !prevProps.inviteSubmitted && this.state.showInviteModal) this.toggleInviteModal();
    if (this.props.logInvitees !== prevProps.logInvitees) {
      const selectedMembers = this.state.selectedMembers.concat(this.props.logInvitees);
      this.setState({ selectedMembers });
    }
  }

  searchInputChangedHandler = (event) => {
    const updatedSearchInput = event.target.value.charAt(0) === ' ' ? event.target.value.substring(1) : event.target.value;
    if (updatedSearchInput.length === 0) {
      this.setState({ userSearchResults: [] });
    }
    // In order to decrease the number of api requests to the server,
    // If the user is just adding a letter to their search input or deleting a letter from the end of their search string
    /// We'll filter the search results rather than ping the API
    else if (
      this.props.userSearchResults &&
      (this.state.searchInput.startsWith(updatedSearchInput) || updatedSearchInput.startsWith(this.state.searchInput)) &&
      this.state.searchInput.length > 0
    ) {
      const filteredUserSearchResults = this.props.userSearchResults.filter((user) => {
        const userFullName = `${user.FirstName} ${user.LastName}`;
        return userFullName.toLowerCase().includes(updatedSearchInput.toLowerCase()) === true;
      });
      this.setState({ userSearchResults: filteredUserSearchResults });
    } else {
      this.props.onSearchUsers(updatedSearchInput);
    }
    this.setState({ searchInput: updatedSearchInput });
  };

  inputChangedHandler = (event, fieldName) => {
    const updatedControls = updateObject(this.state.controls, {
      [fieldName]: updateObject(this.state.controls[fieldName], {
        value: event.target.value,
        valid: checkValidity(event.target.value, this.state.controls[fieldName].validation),
        touched: true,
      }),
    });

    const formIsValid = updatedControls.email.valid === true || updatedControls.mobileNumber.valid === true ? updatedControls.firstName.valid : false;
    this.setState({ controls: updatedControls, formIsValid });
  };

  handleMemberSelection = (selectedMember) => {
    let selectedMembers = [...this.state.selectedMembers];
    if (this.state.selectedMembers.map((member) => member.UserId).includes(selectedMember.UserId)) {
      selectedMembers = [...this.state.selectedMembers.filter((member) => selectedMember.UserId !== member.UserId)];
    } else {
      selectedMembers = [...this.state.selectedMembers, selectedMember];
    }

    const formIsValid = selectedMembers.length > 0 ? true : this.state.formIsValid;
    this.setState({ selectedMembers, formIsValid });
  };

  handleNewUserInvite = () => {
    this.props.handleLogInviteNewUser(
      this.props.log.Log.Id,
      this.state.controls.firstName.value,
      this.state.controls.email.value,
      this.state.controls.mobileNumber.value,
      this.state.controls.message.value,
    );
  };

  toggleInviteModal = () => {
    // reset form contents on load/unload
    const updatedControls = updateObject(this.state.controls, {
      firstName: updateObject(this.state.controls.firstName, {
        value: '',
        valid: false,
        touched: false,
      }),
      email: updateObject(this.state.controls.email, {
        value: '',
        valid: false,
        touched: false,
      }),
      mobileNumber: updateObject(this.state.controls.mobileNumber, {
        value: '',
        valid: false,
        touched: false,
      }),
      message: updateObject(this.state.controls.message, {
        value: `Hi there! I would like to invite you to a log I’ve created for us using Riza. Check it out! \r\n\n-${this.props.postingAs.FirstName}`,
        valid: true,
        touched: false,
      }),
    });
    this.setState({ controls: updatedControls, showInviteModal: !this.state.showInviteModal });
  };

  render = () => {
    let inviteModal = null;
    const existingMemberIds =
      this.props.existingMembers && this.props.existingMembers.length > 0 ? this.props.existingMembers.map((member) => member.UserId) : [];
    // only show search results for users who are not already members of the log
    const searchResults = this.state.userSearchResults.filter((searchResult) => !existingMemberIds.includes(searchResult.UserId));
    let searchResultItems = null;
    if (searchResults.length > 0) {
      searchResultItems = searchResults.map((member) => {
        const selected = this.state.selectedMembers.findIndex((invitedUser) => invitedUser.UserId === member.UserId) !== -1;
        const imageURL = _get(member, 'ImageURL', _get(member, 'ThumbURL'));
        return (
          <div
            key={member.UserId}
            className={selected ? [classes.Member, classes.Selected].join(' ') : classes.Member}
            onClick={() => this.handleMemberSelection(member)}
          >
            <div className={classes.FilterSelected}>
              <FontAwesomeIcon icon="check" className={classes.CheckMark} />
            </div>
            {imageURL ? (
              <img src={imageURL} alt={`${member.FirstName}-image`} style={{ border: `2px solid ${getRgbFromColorName(member.Color)}` }} />
            ) : (
              <div className={classes.ImagePlaceholder} style={{ backgroundColor: getRgbFromColorName(member.Color) }} />
            )}
            <p className={classes.FirstName}>{member.FirstName}</p>
            <p className={classes.LastName}>{member.LastName}</p>
          </div>
        );
      });
    }
    const addMemberFormFields = ['firstName', 'email', 'mobileNumber'];

    if (this.state.showInviteModal && this.props.log) {
      inviteModal = (
        <Modal show className="MemberInviteModal" closeOnOutsideClick={false} close={this.toggleInviteModal}>
          <div className={classes.InviteModalContents}>
            <div className={classes.Header}>
              <FontAwesomeIcon icon="times" onClick={this.toggleInviteModal} className={classes.CloseIcon} />
              <div className={classes.HeaderMessage}>
                <h3>Invite a friend to join this log on Riza</h3>
                <h2>{truncateText(this.props.log.Log.Name, 30)}</h2>
              </div>
            </div>
            <div className={classes.InviteMemberForm}>
              {addMemberFormFields.map((formField) => (
                <Input
                  key={formField}
                  fontIcon={this.state.controls[formField].fontIcon}
                  elementType={this.state.controls[formField].elementType}
                  elementConfig={this.state.controls[formField].elementConfig}
                  defaultValue={this.state.controls[formField].value}
                  inputClassName={`InviteMembers${formField}`}
                  placeholder={this.state.controls[formField].elementConfig.placeholder}
                  invalid={!this.state.controls[formField].valid}
                  shouldValidate={this.state.controls[formField].validation}
                  validationError={
                    this.state.controls[formField].validation && this.state.controls[formField].value.length > 0
                      ? this.state.controls[formField].validation.validationError
                      : null
                  }
                  touched={this.state.controls[formField].touched}
                  changed={(event) => this.inputChangedHandler(event, formField)}
                />
              ))}
              <div className={classes.InviteMessageField}>
                <h4>Message</h4>
                <textarea
                  className={classes.InviteMessageField}
                  value={this.state.controls.message.value}
                  onChange={(event) => this.inputChangedHandler(event, 'message')}
                />
              </div>
              <button
                className={this.state.formIsValid ? classes.SubmitInviteButton : [classes.SubmitInviteButton, classes.Disabled].join(' ')}
                onClick={this.handleNewUserInvite}
              >
                Done
              </button>
            </div>
          </div>
        </Modal>
      );
    }

    return (
      <div className={classes.AddMembersContainer}>
        {inviteModal}
        <div className={classes.Header}>
          <FontAwesomeIcon icon="times" onClick={this.props.cancel} className={classes.CloseAddMembersIcon} />
          <h3>Add Members</h3>
          <button
            className={this.state.selectedMembers.length > 0 ? classes.AddMembersButton : [classes.AddMembersButton, classes.Disabled].join(' ')}
            onClick={() =>
              this.props.handleLogAddRemoveMembers(
                this.props.log.Log.Id,
                this.state.selectedMembers.map((user) => user.UserId),
                null,
                null,
              )
            }
          >
            Add
          </button>
        </div>
        <div className={classes.SelectedMembers}>
          {this.state.selectedMembers.map((selectedMember, i) => (
            <div key={`selected-member-${i}`} className={classes.SelectedMember}>
              <span>{`${selectedMember.FirstName} ${selectedMember.LastName}`}</span>
              {selectedMember.InviteType ? null : (
                <FontAwesomeIcon
                  icon="minus-circle"
                  className={classes.RemoveInviteeIcon}
                  onClick={() => this.handleMemberSelection(selectedMember)}
                />
              )}
              {selectedMember.InviteType && selectedMember.InviteType.includes('Email') ? (
                <FontAwesomeIcon icon="envelope" className={classes.InviteTypeIcon} />
              ) : null}
              {selectedMember.InviteType && selectedMember.InviteType.includes('Text') ? (
                <FontAwesomeIcon icon="phone" className={classes.InviteTypeIcon} />
              ) : null}
            </div>
          ))}
        </div>
        <div className={classes.AddMembersActionContainer}>
          <div className={classes.MembersSearch}>
            <Input
              value={this.state.searchInput}
              placeholder="Add member(s) to this log"
              elementType="input"
              inputClassName="AddMemberSearch"
              changed={this.searchInputChangedHandler}
            />
            <div className={classes.SearchResults}>{searchResultItems}</div>
          </div>
          <div className={classes.InviteMembers}>
            <p>Can’t find existing member?</p>
            <h3 onClick={this.toggleInviteModal}>Invite friends to join Riza</h3>
          </div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    userSearchResults: state.user.userSearchResults,
    inviteSubmitted: state.logs.inviteSubmitted,
    logInvitees: state.logs.logInvitees,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSearchUsers: (searchFor) => dispatch(actions.userSearch(searchFor)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddMembers);
